import { JobUpdate } from '@/models'
import { default as IJobRequestMap, default as JobRequestMap } from '@/models/jobs/JobRequestMap'
import ValueBasedTrigger from '@/models/jobs/ValueBasedTrigger'
import { cloneDeep } from 'lodash'

class JobRequestMapper {
  jobRequestMap: IJobRequestMap
  jobData: any
  jobScheduleData: any

  constructor() {
    this.jobRequestMap = new JobRequestMap()
  }

  private isOneTimeAssetBased(job: any): boolean {
    const hasTargetOdometer = job.targetOdometerReading != null && job.targetOdometerReading > 0
    const hasTargetMachineHours = job.targetMachineHours != null && job.targetMachineHours > 0
    const hasRecurringOdometer = job.options?.odometerTrigger?.value > 0
    const hasRecurringMachineHours = job.options?.machineHoursTrigger?.value > 0

    return (hasTargetOdometer || hasTargetMachineHours) && !hasRecurringOdometer && !hasRecurringMachineHours
  }

  private buildJobOptions(job: any) {
    if (this.isOneTimeAssetBased(job)) {
      return {
        odometerTrigger: null,
        machineHoursTrigger: null,
        timeBasedTrigger: null
      }
    }
    if (job.isOdometerBasedSelected === true && job.options?.odometerTrigger?.value > 0) {
      const odometerTrigger = new ValueBasedTrigger(job.options?.odometerTrigger)
      if (!odometerTrigger.numberOfOccurrences) {
        odometerTrigger.numberOfOccurrences = 2
      }
      return {
        odometerTrigger,
        machineHoursTrigger: null,
        timeBasedTrigger: null
      }
    }

    if (job.isMachineHoursBasedSelected === true && job.options?.machineHoursTrigger?.value > 0) {
      const machineHoursTrigger = new ValueBasedTrigger(job.options?.machineHoursTrigger)
      if (!machineHoursTrigger.numberOfOccurrences) {
        machineHoursTrigger.numberOfOccurrences = 2
      }
      return {
        odometerTrigger: null,
        machineHoursTrigger,
        timeBasedTrigger: null
      }
    }

    if (job.isTimeBasedSelected === true && job.options?.timeBasedTrigger?.pattern != null) {
      return {
        odometerTrigger: null,
        machineHoursTrigger: null,
        timeBasedTrigger: job.options?.timeBasedTrigger
      }
    }

    return {
      odometerTrigger: null,
      machineHoursTrigger: null,
      timeBasedTrigger: null
    }
  }

  private toJobUpdateFromJobForm(job: any): IJobRequestMap {
    const jobUpdate = new JobUpdate(job)
    const options = this.buildJobOptions(job)
    ;(jobUpdate as any).options = options

    if (this.isOneTimeAssetBased(job)) {
      ;(jobUpdate as any).targetOdometerReading = job.targetOdometerReading ?? null
      ;(jobUpdate as any).targetMachineHours = job.targetMachineHours ?? null
    } else {
      ;(jobUpdate as any).targetOdometerReading = null
      ;(jobUpdate as any).targetMachineHours = null
    }

    this.jobRequestMap.jobRequestData = jobUpdate
    return this.jobRequestMap
  }

  public toJobUpdate(jobOriginal: any) {
    const job = cloneDeep(jobOriginal)
    return this.toJobUpdateFromJobForm(job)
  }
}

export default JobRequestMapper
